import React, { useEffect } from "react";
import AOS from 'aos';
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';
import profile from "../images/liaison/profile.png";
import rating_star from "../images/liaison/Rating_star.png";

function TestimonialSlider() {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const { pathname } = useLocation();
  const page = pathname.split("/").filter(Boolean);

  console.log(page);

  let key;
  if (page.length === 2) {
    key = page[1];
  } else if (page.length === 1) {
    key = page[0];
  }



  const testimonials = {
    home: [
      {
        name: "Ramesh K",
        occupation: "Real Estate Investor",
        content: "Property sale deed registration with Lands and Lands was smooth and transparent. Their staff followed up regularly from Document drafting to Registration. Highly trustworthy!"
      },
      {
        name: "Vivek S",
        occupation: "Property Developer",
        content: "From land identification to layout approval, Lands and Lands was a reliable partner. Their development expertise and end-to-end service simplified our Layout project greatly."
      },
      {
        name: "Vijay Kumar",
        occupation: "Professor",
        content: "After months of searching, Lands and Lands found us the perfect 1200 sq ft plot in Saravanampatti and even arranged bank loan documentation. The handover was completed in just 45 days with clear title deeds.",
      },
      {
        name: "Sanjana",
        occupation: "Architect",
        content: "When we needed quick survey results for our project financing application, their team completed comprehensive digital mapping within 48 hours and provided detailed survey reports.",
      }
    ],
    industries: [
      {
        name: "Swathi Balan",
        occupation: "Energy Consultant",
        content: 'Lands and Lands helped us acquire land for our solar project. Their team was knowledgeable about energy sector approvals and guided us through each step. The process was streamlined and transparent.',
      },
      {
        name: "Anand Kumar",
        occupation: "Startup Founder",
        content: "Securing office space for our IT startup was effortless with Lands and Lands. From due diligence to final registration, the team ensured swift service and great facility options.",
      },
      {
        name: "Vivek S",
        occupation: "Property Developer",
        content: "From land identification to layout approval, Lands and Lands was a reliable partner. Their development expertise and end-to-end service simplified our Layout project greatly."
      },
      {
        name: "Amit Raj",
        occupation: "Operations Head",
        content: "We partnered with Lands and Lands for a warehouse in Coimbatore. Their expertise in logistics solutions ensured our facility met all standards and was ready for operations ahead of time.",
      },
    ],
    liaison: [
      {
        name: "Shyam Prasad",
        occupation: "Architect",
        content: "Lands and Lands made our building plan approval process simple and stress-free. Their liaison team handled all paperwork efficiently and kept us updated throughout. Highly reliable service",
      },
      {
        name: "Ganapathy R",
        occupation: "Land Owner",
        content: "Land use change approvals were a breeze with Lands and Lands. The team explained everything clearly and delivered within promised timelines."
      },
      {
        name: "Hema suresh",
        occupation: "Layout Developer",
        content: "“From design to layout sanction, Lands and Lands handled everything efficiently. Their knowledge of Government regulations and meticulous work made it seamless."
      },
      {
        name: "Anjali Devi",
        occupation: "Architect",
        content: "Obtaining HACA clearance for our Resort project near the Western Ghats seemed challenging. Lands and Lands coordinated with authorities and submitted detailed  documents that ensured quick NOC approval."
      },
    ],
    residential: [
      {
        name: "Priya Narayanan",
        occupation: "Home Maker",
        content: "Choosing Lands and Lands for our new home was a wonderful experience. Their transparency and attention to detail gave us complete confidence throughout the buying process."
      },
      {
        name: "Karthik Suresh",
        occupation: "IT Professional",
        content: 'Lands and Lands has set a benchmark for residential services in Coimbatore. The quality of the construction and seamless documentation process made our move-in stress-free',
      },
      {
        name: "Vijay Kumar",
        occupation: "Professor",
        content: "After months of searching, Lands and Lands found us the perfect 1200 sq ft plot in Saravanampatti and even arranged bank loan documentation. The handover was completed in just 45 days with clear title deeds.",
      },
      {
        name: "Lavanya D",
        occupation: "Advocate",
        content: 'What impressed me most was their post-sales support. Even after moving in, they helped resolve minor electrical issues and connected us with reliable local contractors for interior work. True customer-first approach',
      },
    ],
    retail: [
      {
        name: 'Meera Krishnan',
        occupation: "Store Operations Manager",
        content: "Lands and Lands provided us with perfect retail space for our brand’s expansion. The location was prime, and their staff handled all approvals swiftly. We found them extremely professional and customer-focused.",
      },
      {
        name: "Jagan Mohan",
        occupation: "Business Manager",
        content: "Our retail project with Lands and Lands went smoothly from site selection to registration. The company’s local knowledge and efficient coordination helped us open on schedule. Excellent service and support!",
      },
      {
        name: "Vivek S",
        occupation: "Entrepreneur",
        content: "Finding the right location for our Book stall was crucial. Their team analyzed foot traffic patterns and competitor density before recommending three excellent options. The chosen 800 sq ft space has generated 30% higher revenue than our previous location.",
      },
      {
        name: 'Sangeetha M',
        occupation: "Boutique Owner",
        content: "Their market research data helped us understand local customer preferences before setting up our boutique. The location suggestions were spot-on, and we recovered our investment within eight months of opening",
      }
    ],
    logistics: [
      {
        name: "Amit Raj",
        occupation: "Operations Head",
        content: "We partnered with Lands and Lands for a warehouse in Coimbatore. Their expertise in logistics solutions ensured our facility met all standards and was ready for operations ahead of time.",
      },
      {
        name: "Rakesh Gupta",
        occupation: "Supply Chain Manager",
        content: "The Lands and Lands team managed our logistics property requirements professionally. The site was ideally located with all necessary infrastructure, and documentation was handled promptly",
      },
      {
        name: "Manoj Pillai",
        occupation: "Logistics Manager",
        content: "Our 15,000 sq ft warehouse requirement in Madukkarai was fulfilled perfectly. Lands and Lands coordinated with TNEB for three-phase power connection and ensured proper loading dock specifications.",
      },
      {
        name: "Priya S",
        occupation: "Agri Entreprenuer",
        content: "They understood our cold storage needs and identified a location with excellent highway connectivity. The site has proper drainage systems and adequate parking for 20+ trucks. Distribution efficiency improved by 25% after the move",
      },
    ],
    energy: [
      {
        name: "Swathi Balan",
        occupation: "Energy Consultant",
        content: 'Lands and Lands helped us acquire land for our solar project. Their team was knowledgeable about energy sector approvals and guided us through each step. The process was streamlined and transparent.',
      },
      {
        name: "Saravanan P",
        occupation: "Project Engineer",
        content: "Our wind energy infrastructure expansion with Lands and Lands was hassle-free. Their local expertise and clear communication made sure everything moved as planned. Excellent coordination!"
      },
      {
        name: "Sneha Kannan",
        occupation: "Energy Consultant",
        content: "For our 2MW solar project, Lands and Lands identified suitable agricultural land with proper grid connectivity. They coordinated with TANGEDCO for power evacuation approvals and ensured minimal transmission losses."
      },
      {
        name: "Geetha R",
        occupation: "Energy Entreprenuer",
        content: "When we needed additional land for wind turbine installation, their quick identification of suitable sites with optimal wind speeds helped us expand our renewable portfolio ahead of competitors.",
      }
    ],
    it: [
      {
        name: "Anand Kumar",
        occupation: "Startup Founder",
        content: "Securing office space for our IT startup was effortless with Lands and Lands. From due diligence to final registration, the team ensured swift service and great facility options.",
      },
      {
        name: "Deepika M",
        occupation: "Software Developer",
        content: "Lands and Lands understands the IT sector’s needs well. They offered us flexible workspace solutions and handled all compliance efficiently. Highly recommended for tech businesses!",
      },
      {
        name: "Mahesh K",
        occupation: "Startup Founder",
        content: "Our IT services company needed flexible workspace for 50 employees in IT corridor. Lands and Lands found us a modern facility with backup power, high-speed internet infrastructure, and parking for all staff within our budget.",
      },
      {
        name: "Keerthi K",
        occupation: "COO",
        content: "When we needed to scale up quickly for a major project, they arranged additional workspaces in the same building within a week. Their property management connections proved invaluable for rapid expansion",
      }
    ],
    commercial: [
      {
        name: "Rajesh Varma",
        occupation: "Showroom Owner",
        content: "We chose Lands and Lands for our commercial showroom, and the experience exceeded expectations. Their strong Industrial knowledge made the approval process easy and fast.",
      },
      {
        name: "Lakshmi Devi",
        occupation: "Business Owner",
        content: "Professional service from site visit to final handover. Lands and Lands ensured our commercial property needs were met with diligence, accuracy, and regular updates. A huge jump in our business",
      },
      {
        name: "Murali P",
        occupation: "Business Owner",
        content: "Finding commercial space for our restaurant chain expansion was challenging until Lands and Lands suggested three prime locations with proper kitchen exhaust provisions and liquor license compatibility.",
      },
      {
        name: "Sanjay G",
        occupation: "Used Car Retailer",
        content: "Our automobile dealership required 25,000 sq ft with proper vehicle display area and service bay access. Lands and Lands identified the perfect corner plot on Trichy Road with high visibility and adequate customer parking.",
      }
    ],
    development: [
      {
        name: "Vivek S",
        occupation: "Property Developer",
        content: "From land identification to layout approval, Lands and Lands was a reliable partner. Their development expertise and end-to-end service simplified our Layout project greatly."
      },
      {
        name: "Parthiban T",
        occupation: "Construction Project Manager",
        content: "Lands and Lands handled the land sourcing for our Apartment project with professionalism and integrity. Transparent processes and frequent updates made us feel secure at every stage."
      },
      {
        name: "Nalini N",
        occupation: "Construction Project Manager",
        content: "Their site selection expertise identified a location with excellent appreciation potential. The suggested property in Vadavalli has seen 40% value increase even before project completion, validating their market insight",
      },
      {
        name: "Nikilesh A",
        occupation: "Builder",
        content: "Our 50-unit villa project required comprehensive planning support. Lands and Lands managed everything from property sourcing, surveying, soil testing, coordination to RERA registration"
      },

    ],
    dtcp: [
      {
        name: "Shyam Prasad",
        occupation: "Architect",
        content: "Lands and Lands made our building plan approval process simple and stress-free. Their liaison team handled all paperwork efficiently and kept us updated throughout. Highly reliable service",
      },
      {
        name: "Anitha Kumar",
        occupation: "First time Home Builder",
        content: "The approval was granted faster than expected, thanks to the professional approach of Lands and Lands and their accurate document curation. Their expertise and follow-through saved us valuable time."
      },
      {
        name: "Mohan Srinivas",
        occupation: "Contractor",
        content: "The team at Lands and Lands helped us prepare and submit our building plans without any hassle. Their knowledge of local regulations made the process smooth and efficient."
      },
      {
        name: "Vineeth",
        occupation: "Civil Engineer",
        content: "Clear communication and prompt guidance from Lands and Lands ensured our building plan met all requirements on the first attempt. Highly recommended for anyone needing plan approvals.",
      },
    ],
    landuse: [
      {
        name: "Ganapathy R",
        occupation: "Land Owner",
        content: "Land use change approvals were a breeze with Lands and Lands. The team explained everything clearly and delivered within promised timelines."
      },
      {
        name: "Mohammed Faizal",
        occupation: "Real Estate Advisor",
        content: "The experts at Lands and Lands managed all the necessary approvals for land use changes. Their thoroughness and timely communication stood out."
      },
      {
        name: "Jai Suresh",
        occupation: "Land Owner",
        content: "Their thorough understanding of land classification procedures and stamp duty implications helped us structure the conversion cost-effectively while maintaining full legal compliance",
      },
      {
        name: "Aravind P",
        occupation: "Real Estate Investor",
        content: "Their thorough understanding of land classification procedures and stamp duty implications helped us structure the conversion cost-effectively while maintaining full legal compliance."
      },
    ],
    layoutapproval: [
      {
        name: "Hema suresh",
        occupation: "Layout Developer",
        content: "“From design to layout sanction, Lands and Lands handled everything efficiently. Their knowledge of Government regulations and meticulous work made it seamless."
      },
      {
        name: "Sathish Kumar",
        occupation: "Construction Project Manager",
        content: "Layout approvals came through faster than expected thanks to Lands and Lands. They were always available for any type of clarifications."
      },
      {
        name: "Vinod R",
        occupation: "Construction Project Managaer",
        content: "Our 40-Plot layout required detailed infrastructure planning approvals. Lands and Lands coordinated with PWD for road specifications, water authority for supply connections, and electricity board for transformer placement"
      },
      {
        name: "Krishna",
        occupation: "Property Developer",
        content: "Their systematic documentation of all layout components including road width, sewage systems, and OSR calculations ensured first-time approval without any revision requirements."
      },
    ],
    hacanoc: [
      {
        name: "Anjali Devi",
        occupation: "Architect",
        content: "Obtaining HACA clearance for our Resort project near the Western Ghats seemed challenging. Lands and Lands coordinated with authorities and submitted detailed  documents that ensured quick NOC approval."
      },
      {
        name: "Anajli Devi",
        occupation: "Architect",
        content: 'Efficient handling of HACA NoC applications by Lands and Lands. Their prompt updates and accurate documentation made the whole process a hassle free experience',
      },
      {
        name: "Senthil R",
        occupation: "Site Manager",
        content: "The team's proactive coordination with HACA officials during the design phase prevented potential objections later. They arranged site inspections and technical presentations that expedited the approval process."
      },
      {
        name: "Prabhu M",
        occupation: "Construction Project Sueprvisor",
        content: "HACA NoC for our site was obtained with zero hassles, thanks to the competent Lands and Lands liaison team. Professional and prompt service!"
      }
    ],
    registration: [
      {
        name: "Ramesh K",
        occupation: "Real Estate Investor",
        content: "Property sale deed registration with Lands and Lands was smooth and transparent. Their staff followed up regularly from Document drafting to Registration. Highly trustworthy!"
      },
      {
        name: "Vanitha T",
        occcupation: "First- time home buyer",
        content: "The registration process was thorough and clear. Lands and Lands guided us step by step, making our first home ownership experience stress-free",
      },
      {
        name: "Mukesh N",
        occupation: "Real Estate Investor",
        content: "Their team's attention to detail during document verification caught potential discrepancies in survey numbers early. The corrective measures were completed before registration day, ensuring smooth execution",
      },
      {
        name: "Pallavi S",
        occupation: "First-time home buyer",
        content: "Their team's attention to detail during document verification caught potential discrepancies in survey numbers early. The corrective measures were completed before registration day, ensuring smooth execution"
      }
    ],
    digitalsurvey: [
      {
        name: "Arjun P",
        occupation: "Investor",
        content: "“We used Lands and Lands to survey a  property. Their team was on time at the Property with advanced equipment and shared detailed maps, helping us plan better."
      },
      {
        name: "Mukesh K",
        occupation: "Land Owner",
        content: "The digital survey service from Lands and Lands was prompt, accurate, and affordable. Their expertise showed throughout the process, their drawings were detailed and easy to understand."
      },
      {
        name: "Sanjana",
        occupation: "Architect",
        content: "When we needed quick survey results for our project financing application, their team completed comprehensive digital mapping within 48 hours and provided detailed survey reports.",
      },
      {
        name: "Ramesh K",
        occupation: "Industrialist",
        content: "Our industrial site required a precise topographical survey for factory layout planning. Lands and Lands conducted comprehensive drone mapping and provided detailed contour data that helped optimize our building placement and reduce earthwork costs."
      }
    ]
  }




  return (
    <>

      <div className="max-w-[1240px] mx-auto my-[60px] cursor-pointer sm:my-[80px]">

        <div className='my-[50px]'>
          <h2 className="heading" data-aos="fade-up">Client Testimonials</h2>
          <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" data-aos-duration="800"/>
        </div>

        <Swiper
          className="!px-12"
          modules={[Navigation, Pagination, A11y]}
          // spaceBetween={10}
          // slidesPerView={3}
          navigation
          // pagination={{ clickable: true }}
          scrollbar={{ draggable: true }}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 50 },
            480: { slidesPerView: 1, spaceBetween: 50 },
            768: { slidesPerView: 1, spaceBetween: 50 },
            1024: { slidesPerView: 2, spaceBetween: 50 },
          }}
        >

          {testimonials[key].map((items, index) => {
            return (
              <SwiperSlide key={index}>
                <div className="max-w-[530px] mx-auto h-fit  bg-[#F8F6F6] border-[2px] border-[#EDEAEA] rounded-[8px] p-[20px] shadow-xl shadow-[#E4e4e4] md:p-[45px] lg:h-[410px]" data-aos="fade-up">
                  <p className="text-font-grey text-[18px] leading-[30px] text-center font-alibaba sm:text-[20px] sm:leading-[32px]">{items.content}</p>

                  <div className="mt-[50px] text-center">
                    <h1 className="font-noto text-[25px] leading-[35px] text-hblack font-bold">{items.name}</h1>
                    <p className="text-font-brown text-[16px] leading-[17px] font-normal font-alibaba mt-3">{items.occupation}</p>
                  </div>

                </div>
              </SwiperSlide>
            )
          })}

        </Swiper>


      </div>

    </>
  );

  // return (
  //   <>

  //   <div className="max-w-6xl mx-auto my-[130px] cursor-pointer">

  //       <div className='my-[50px]'>
  //         <h2 className="heading !font-noto" data-aos="fade-up">Client Testimonials</h2>
  //         <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]'/>
  //       </div>

  //       <Swiper className="!p-[45px]"
  //         modules={[Navigation, Pagination, A11y]}
  //         // spaceBetween={10}
  //         // slidesPerView={3}
  //         navigation
  //         // pagination={{ clickable: true }}
  //         scrollbar={{ draggable: true }}
  //         breakpoints={{
  //           320: { slidesPerView: 1, spaceBetween: 50 },
  //           480: { slidesPerView: 1, spaceBetween: 50 },
  //           768: { slidesPerView: 1, spaceBetween: 50 },
  //           1024: { slidesPerView: 2, spaceBetween: 50 },
  //         }}
  //       >

  //         <SwiperSlide>
  //           <div className="max-w-[530px] mx-auto bg-[#F8F6F6] border-[2px] border-[#EDEAEA] rounded-[8px] p-[45px] text-center font-[alibabasans] shadow-lg">
  //             <p className="text-[#5F5D5E] text-[20px] leading-[32px]">Lorem ipsum dolor sit amet cons ectetur. Amet eu eget in curabitur est pellentesque a. Gravida ipsum pharetra eu lectus. Condimentum tristique elit  risus est. </p>

  //             <div className="mt-[50px]">
  //               <h1 className="font-noto text-[20px] leading-[35px]">Ramamoorthy</h1>
  //               <p className="text-[#575857] font-bold">Auditor</p>
  //             </div>

  //           </div>
  //         </SwiperSlide>

  //         <SwiperSlide>
  //           <div className="max-w-[530px] mx-auto bg-[#F8F6F6] border-[2px] border-[#EDEAEA] rounded-[8px] p-[45px] text-center font-[alibabasans] shadow-lg">
  //             <p className="text-[#5F5D5E] text-[20px] leading-[32px]">Lorem ipsum dolor sit amet cons ectetur. Amet eu eget in curabitur est pellentesque a. Gravida ipsum pharetra eu lectus. Condimentum tristique elit  risus est. </p>

  //             <div className="mt-[50px]">
  //               <h1 className="font-noto text-[20px] leading-[35px]">Ramamoorthy</h1>
  //               <p className="text-[#575857] font-bold">Auditor</p>
  //             </div>

  //           </div>
  //         </SwiperSlide>

  //          <SwiperSlide>
  //           <div className="max-w-[530px] mx-auto bg-[#F8F6F6] border-[2px] border-[#EDEAEA] rounded-[8px] p-[45px] text-center font-[alibabasans] shadow-lg">
  //             <p className="text-[#5F5D5E] text-[20px] leading-[32px]">Lorem ipsum dolor sit amet cons ectetur. Amet eu eget in curabitur est pellentesque a. Gravida ipsum pharetra eu lectus. Condimentum tristique elit  risus est. </p>

  //             <div className="mt-[50px]">
  //               <h1 className="font-noto text-[20px] leading-[35px]">Ramamoorthy</h1>
  //               <p className="text-[#575857] font-bold">Auditor</p>
  //             </div>

  //           </div>
  //         </SwiperSlide>

  //          <SwiperSlide>
  //           <div className="max-w-[530px] mx-auto bg-[#F8F6F6] border-[2px] border-[#EDEAEA] rounded-[8px] p-[45px] text-center font-[alibabasans] shadow-lg">
  //             <p className="text-[#5F5D5E] text-[20px] leading-[32px]">Lorem ipsum dolor sit amet cons ectetur. Amet eu eget in curabitur est pellentesque a. Gravida ipsum pharetra eu lectus. Condimentum tristique elit  risus est. </p>

  //             <div className="mt-[50px]">
  //               <h1 className="font-noto text-[20px] leading-[35px]">Ramamoorthy</h1>
  //               <p className="text-[#575857] font-bold">Auditor</p>
  //             </div>

  //           </div>
  //         </SwiperSlide>

  //       </Swiper>

  //   </div>

  //   </>
  // );
}

export default TestimonialSlider;
